import { httpRequest } from "@services/http"

/*
    The audience rows under one campaign in the Monitor table.

    No conversions field: conversions are scoped by population segment, which
    belongs to the campaign rather than to an audience, so they cannot be split
    between the audiences a campaign served. See CmdGetCampaignAudiences.

    Fetched per campaign when its row is expanded — every audience costs its own
    queries server-side, so the table doesn't pay for rows nobody opened.
*/
export type CampaignAudienceRow = {
  id: number
  name: string
  spend_total: number
  impression_count: number
  clicks_total: number
}

export class CommandGetCampaignAudiences {
  async run(engagementId: number, launchId: number): Promise<CampaignAudienceRow[]> {
    const url =
      `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}` +
      `/analytics/?charts=campaign-audiences&launch_id=${launchId}`
    const response = await httpRequest<any>(url, { method: "GET" })
    return response?.charts?.["campaign-audiences"]?.audiences ?? []
  }
}
